export default "__VITE_ASSET__$QKMKvGx__"